import React, { useState } from 'react';
import '../css/header.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faXmark } from '@fortawesome/free-solid-svg-icons';

function Header() {
  // La variable en utilisant le useState
  const [navbarLinksVisible, setNavbarLinksVisible] = useState(false);

  // Juste un toggle off et on
  function toggleNavButton() {
    setNavbarLinksVisible((prevState) => !prevState);
  }

  // Le div de navbar-links a un check pour si navbarLinksVisible est on ou pas 
  // et si on affiche la class ou pas.
  return (
    <nav className="navbar">
      <a className="brand-title" href="/">Nicolas Carriere</a>
      <button
        type="button"
        className="toggle-navbutton"
        onClick={toggleNavButton}
        aria-label={navbarLinksVisible ? 'Close menu' : 'Open menu'}
        aria-expanded={navbarLinksVisible}
      >
        <FontAwesomeIcon icon={navbarLinksVisible ? faXmark : faBars} />
      </button>
      <div className={`navbar-links ${navbarLinksVisible ? 'active' : ''}`}>
        <ul>
          <li>
            <a href='/'>Home</a>
          </li>
          <li>
            <a href='/projects'>Projects</a>
          </li>
          <li>
            <a href='/skills'>Skills</a>
          </li>
          <li>
            <a href='/contact'>Contact</a>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Header;
